const LatLngTools = function() {
	this.distance = function(lat1, lon1, lat2, lon2) {
		lat1 = parseFloat(lat1);
		lon1 = parseFloat(lon1);
		lat2 = parseFloat(lat2);
		lon2 = parseFloat(lon2);

		var R = 6371000;
		var dLat = this.toRad(lat2-lat1);
		var dLon = this.toRad(lon2-lon1);
		var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
				Math.cos(this.toRad(lat1)) * Math.cos(this.toRad(lat2)) *
				Math.sin(dLon/2) * Math.sin(dLon/2);
		var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
		var d = R * c;

		return d;
	};

	this.toRad = function(Value) {
		return Value * Math.PI / 180;
	};

	this.toUTM = function(lat, lng) {

	};

	this.findAngle = function(x1, y1, x2, y2) {
		var y = Math.sin(y2-y1) * Math.cos(x2);
		var x = Math.cos(x1)*Math.sin(x2) -
				Math.sin(x1)*Math.cos(x2)*Math.cos(y2-y1);
		var brng = Math.atan2(y, x) * 180 / Math.PI;

		//console.log(brng);
		return brng;
	};
};

Array.min = function(array) {
	return Math.min.apply(Math, array);
};

export default LatLngTools;
